export enum WREX_CODE_BLOCK {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=132617936
     */
    BUTTON_LABEL = 'FRONT.TEXT_EDITOR.HEADINGS.CODE_BLOCK',
}
